export enum ApplicationScheme {
  CNCS = 'CNCS',
  MSDG = 'MSDG',
  SSDG = 'SSDG',
  AGRIVOLTAIC_1 = 'AGRIVOLTAIC_1',
  AGRIVOLTAIC_2 = 'AGRIVOLTAIC_2',
  OTHER = 'OTHER',
}

export const APPLICATION_SCHEME_SLUGS: Record<ApplicationScheme, string> = {
  [ApplicationScheme.CNCS]: 'cncs',
  [ApplicationScheme.MSDG]: 'msdg',
  [ApplicationScheme.SSDG]: 'ssdg',
  [ApplicationScheme.AGRIVOLTAIC_1]: 'agrivoltaic-one',
  [ApplicationScheme.AGRIVOLTAIC_2]: 'agrivoltaic-two',
  [ApplicationScheme.OTHER]: 'cncs',
};

export function normalizeApplicationScheme(value?: string | null): ApplicationScheme {
  const normalized = (value ?? '').toString().trim().toUpperCase();
  switch (normalized) {
    case ApplicationScheme.CNCS:
      return ApplicationScheme.CNCS;
    case ApplicationScheme.MSDG:
      return ApplicationScheme.MSDG;
    case ApplicationScheme.SSDG:
      return ApplicationScheme.SSDG;
    case ApplicationScheme.AGRIVOLTAIC_1:
      return ApplicationScheme.AGRIVOLTAIC_1;
    case ApplicationScheme.AGRIVOLTAIC_2:
      return ApplicationScheme.AGRIVOLTAIC_2;
    default:
      return ApplicationScheme.OTHER;
  }
}

export function applicationSchemeToSlug(scheme: ApplicationScheme): string {
  return APPLICATION_SCHEME_SLUGS[scheme] ?? APPLICATION_SCHEME_SLUGS[ApplicationScheme.OTHER];
}
